/**
 * Detects visitor country via Shopify IP geo (browsing_context_suggestions),
 * not Markets/checkout selected country. Sets html[data-geo-country] so CSS
 * can hide [data-free-shipping] outside the US.
 *
 * navigator.language region is last-resort only — User-Agent has no country.
 */
(function () {
  const STORAGE_KEY = 'bf-geo-country';

  function getRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function applyCountry(country) {
    if (!country) return;

    const code = String(country).toUpperCase();
    document.documentElement.setAttribute('data-geo-country', code);

    try {
      sessionStorage.setItem(STORAGE_KEY, code);
    } catch (error) {
      // ignore
    }
  }

  function countryFromNavigator() {
    const locales =
      navigator.languages && navigator.languages.length
        ? navigator.languages
        : [navigator.language || navigator.userLanguage];

    for (let i = 0; i < locales.length; i += 1) {
      const match = String(locales[i] || '').match(/[-_]([A-Za-z]{2})$/);
      if (match) return match[1].toUpperCase();
    }

    return null;
  }

  function detectCountry() {
    const url = getRoot() + 'browsing_context_suggestions.json?country[enabled]=true';

    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('geo fetch failed');
        return response.json();
      })
      .then(function (data) {
        const handle =
          data &&
          data.detected_values &&
          data.detected_values.country &&
          data.detected_values.country.handle;

        if (handle) return String(handle).toUpperCase();
        throw new Error('no detected country');
      })
      .catch(function () {
        return countryFromNavigator();
      });
  }

  try {
    const cached = sessionStorage.getItem(STORAGE_KEY);
    if (cached) applyCountry(cached);
  } catch (error) {
    // ignore
  }

  detectCountry().then(function (country) {
    if (country) applyCountry(country);
  });
})();
